<div class="c-progressbagReward">
  <div class="c-progressbagReward__container">
    <div
      class="c-progressbagReward__background"
      theming
      themingGroup="progressivebag"
      themingAsset="reward-background"
      [themingOverride]="progressbagRewardModalData?.properties?.assets">
      <div class="c-progressbagReward__info">
        <div
          class="c-progressbagReward__icon"
          theming
          themingGroup="progressivebag"
          themingAsset="logo"
          [themingOverride]="progressbagRewardModalData?.properties?.assets"></div>

        <div class="c-progressbagReward__subcontainer">
          <div class="c-progressbagReward__text">
            <span class="text title">{{ 'home.live-ops.progressbag.modal-reward.title' | translate | uppercase }}</span>
            <span class="text subtitle">{{ 'home.live-ops.progressbag.modal-reward.subtitle' | translate }}</span>

            <div
              class="c-progressbagReward__text__bg"
              theming
              themingGroup="progressivebag"
              themingAsset="reward-box"
              [themingOverride]="progressbagRewardModalData?.properties?.assets">
              <slotcom-display [classes]="['c-display--large c-display--large--reward']">
                <div
                  displayIcon
                  displayIconPos="left"
                  class="c-display--coin"></div>
                <span
                  class="text"
                  [ngStyle]="{ 'font-size': setFontSize() }"
                  >{{
                    progressbagRewardModalData.reward.credits | number: '1.0-0' : ('common.culture' | translate)
                  }}</span
                >
              </slotcom-display>
            </div>
          </div>
          <div
            class="c-progressbagReward__tree"
            theming
            themingGroup="progressivebag"
            [themingAsset]="'tree-step-' + (progressbagRewardModalData.properties.rewardPosition + 1)"
            [themingOverride]="progressbagRewardModalData?.properties?.assets"></div>
        </div>

        <slotcom-button
          class="c-button--pink"
          (safeClick)="closeModal()"
          audioType="reward">
          {{
            progressbagRewardModalData.properties.buttonText[lang()]
              ? progressbagRewardModalData.properties.buttonText[lang()]
              : ('common.collect' | translate | uppercase)
          }}
        </slotcom-button>
      </div>
    </div>
  </div>
</div>
